import React from 'react';
import { useTranslation } from 'react-i18next';
import CommentIcon from '../../Icons/Comment';
import Notification from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
var PostNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName;
    var t = useTranslation().t;
    return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
            iconComponent: CommentIcon,
        } }, t('comment.info.posted')));
};
PostNotification.displayName = 'PostNotification';
export default PostNotification;
//# sourceMappingURL=PostNotification.js.map